<div class="flex flex-col max-w-240 md:min-w-200 max-h-screen -m-6">

    <!-- Header -->
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">{{dialogTitle}}</div>
        <button mat-icon-button (click)="onClose()" [tabIndex]="-1">
            <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x'"></mat-icon>
        </button>
    </div>

    <form class="flex flex-col flex-auto p-6 sm:p-8 overflow-y-auto" [formGroup]="copyReportForm">
        <fuse-alert [appearance]="'soft'" *ngIf="alert" [dismissible]="true" [dismissed]="false" [type]="alert.type">
            {{alert.message}}
        </fuse-alert>
        <div class="w-full md:mb-0 pb-2">
            <mat-radio-group class="flex" [color]="'primary'"  [formControlName]="'copyReportType'" appearance="outline">
                <mat-radio-button  value="Same">Same</mat-radio-button>
                <mat-radio-button class="pl-2" value="SameAreaInSameProject">SameArea In SameProject</mat-radio-button>
                <mat-radio-button class="pl-2" value="SameProject">SameProject</mat-radio-button>
            </mat-radio-group>
        </div>
        <mat-form-field appearance="outline">
            <mat-label>From Job Number</mat-label>
            <input type="number" matInput [formControlName]="'fromJobNumber'">
            <mat-error *ngIf="copyReportForm.get('fromJobNumber').hasError('required')">
                From Job Number is required
            </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline">
            <mat-label>To Job Number</mat-label>
            <input type="number" matInput [formControlName]="'toJobNumber'">
            <mat-error *ngIf="copyReportForm.get('toJobNumber').hasError('required')">
                To Job Number is required
            </mat-error>
        </mat-form-field>
       
        <mat-form-field appearance="outline">
            <mat-label>Note</mat-label>
            <input matInput [formControlName]="'copyNote'">
        </mat-form-field>

        <div class="flex flex-col sm:flex-row sm:items-center justify-between mt-4 sm:mt-6">
            <div class="-ml-2">

            </div>
            <div class="flex items-center mt-4 sm:mt-0">
                <button class="order-first sm:order-last" mat-flat-button [color]="'primary'" (click)="saveAndClose()" [disabled]="!copyReportForm.valid">
                    Save
                </button>
            </div>
        </div>
    </form>

</div>